module.exports = __webpack_public_path__ + "img/apay.c620c759.png";